import classNames from 'classnames';
import React from 'react';

import { LocalizedMessage } from 'core/l10n/components';
import * as OvationsApi from 'core/ovations-api';
import { questionFieldIsDisabled, questionFieldIsRequired } from 'core/ovations-components/QuestionField';

import QuestionFieldProps from './definitions/QuestionFieldProps';

export type TextQuestionProps = QuestionFieldProps<
    OvationsApi.Types.PromotionTextQuestion,
    OvationsApi.Types.PromotionTextQuestionAnswer,
    React.InputHTMLAttributes<HTMLInputElement>
>;

const getValidationProps = (props: TextQuestionProps) => {
    const question = props.promotionQuestion;
    const shouldValidate = !(props.isCallCenter && !question.validateOnCallCenter);
    return shouldValidate
        ? {
              minLength: question.minimumCharacters,
              maxLength: question.maximumCharacters,
              pattern: question.question.validationRegex || undefined,
          }
        : {};
};

const TextQuestionField: React.SFC<TextQuestionProps> = (props) => {
    const { inputProps = {}, promotionQuestion } = props;
    const { minimumCharacters, maximumCharacters } = props.promotionQuestion;
    const required = questionFieldIsRequired(props);

    const validationProps = getValidationProps(props);

    return (
        <>
            <input
                value={props.answer ? props.answer.value : ''}
                onChange={(e) => {
                    if (!props.onChange) {
                        return;
                    }
                    props.onChange({
                        type: OvationsApi.Enums.QuestionType.Text,
                        value: e.currentTarget.value,
                    });
                }}
                name={promotionQuestion.id}
                disabled={questionFieldIsDisabled(props)}
                required={required}
                type="text"
                {...validationProps}
                {...inputProps}
                className={classNames('form-control', inputProps.className)}
            />
            {promotionQuestion.question.formattingErrorMessage && (
                <span className="invalid-feedback">{promotionQuestion.question.formattingErrorMessage}</span>
            )}
            {!promotionQuestion.question.validationRegex && (
                <span className="invalid-feedback">
                    <LocalizedMessage
                        id="questionForm_text_invalid"
                        values={{ min: minimumCharacters, max: maximumCharacters }}
                    />
                </span>
            )}
        </>
    );
};

export default TextQuestionField;
